module.exports = __webpack_public_path__ + "static/media/ExchangeNetLeasedPortfolio26.e05957fc.jpg";